module.exports = __webpack_public_path__ + "static/img/img_graphics_a.9d89ce6e.png";